import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconAirportShuttle: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.8999 6.69987C18.9999 6.19987 20.2999 6.39987 21.1999 7.29987C21.7999 7.99987 22.0999 8.89987 21.9999 9.89987C21.7999 10.7999 21.0999 11.5999 20.1999 11.9999L8.49992 16.0999C8.09992 16.1999 7.59992 16.2999 7.19992 16.2999C5.89992 16.2999 4.49992 15.5999 3.79992 14.3999L2.09992 11.4999C1.99992 11.2999 1.89992 10.8999 1.99992 10.6999C2.09992 10.4999 2.29992 10.1999 2.59992 10.0999L4.59992 9.09986C4.89992 8.89987 5.39992 8.99987 5.69992 9.29987L7.19992 10.7999L8.09992 10.2999L4.19992 5.59986C3.99992 5.39986 3.99992 5.09986 3.99992 4.79987C4.09992 4.49987 4.29992 4.19987 4.59992 4.09987L6.59992 3.09987C6.89992 2.99987 7.19992 2.99987 7.49992 3.19987L14.8999 7.79987L17.8999 6.69987ZM7.99992 14.1999L19.4999 10.0999C19.6999 9.99987 19.8999 9.79987 19.9999 9.49987C19.9999 9.19986 19.9999 8.89987 19.7999 8.79987C19.5999 8.49987 19.0999 8.39987 18.7999 8.59986H18.6999L15.1999 9.79987C14.8999 9.89987 14.5999 9.89986 14.2999 9.69986L6.99992 5.09986L6.59992 5.29987L10.4999 10.0999C10.6999 10.2999 10.7999 10.5999 10.6999 10.8999C10.6999 11.1999 10.4999 11.4999 10.1999 11.5999L8.09992 12.5999C7.29992 12.9999 6.39992 12.7999 5.79992 12.0999L4.79992 11.0999L4.39992 11.2999L5.59992 13.2999C6.09992 14.1999 7.09992 14.4999 7.99992 14.1999ZM4.99988 18.9999H18.9999C19.5999 18.9999 19.9999 19.3999 19.9999 19.9999C19.9999 20.5999 19.5999 20.9999 18.9999 20.9999H4.99988C4.39988 20.9999 3.99988 20.5999 3.99988 19.9999C3.99988 19.3999 4.39988 18.9999 4.99988 18.9999Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
